<style lang="scss" scoped>
.error404 {
	margin: 0 auto;
	text-align: center;
	h1 {
		font-size: 2em;
		text-transform: uppercase;
		color: red;
	}
}
</style>

<template lang="pug">
.error404
	h1 Error 404
	.error404__message
		h4 Oops, we couldn't find what you're looking for!
		el-button(type='primary', @click="clickButton") GO HOME
</template>

<script>
export default {
	name: "404",
	methods: {
		clickButton() {
			this.$router.push("/");
		}
	}
};
</script>
